import React from 'react';
import qs from 'qs';
import Prismic from 'prismic-javascript';
import { linkResolver } from '../../api/renderPrismicData';

const apiEndpoint = 'https://jtvsuriname.prismic.io/api/v2';

export default class Preview extends React.Component {
  componentWillMount() {
    this.preview(this.props);
  }

  preview(props) {
    const params = qs.parse(this.props.location.search.slice(1));
    Prismic.getApi(apiEndpoint)
      .then(api => {
        api.previewSession(params.token, linkResolver, '/')
          .then(url => {
            props.history.push(url);
          });
      });
  }

  render() {
    return <p>Loading previews...</p>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Preview/index.js